export default function AppSplashScreen({ message, description }) {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[#f6f8ff] px-6" role="status" aria-live="polite" aria-busy="true">
      <div className="splash-orb splash-orb-one" aria-hidden="true" />
      <div className="splash-orb splash-orb-two" aria-hidden="true" />

      <div className="relative z-10 flex min-h-screen items-center justify-center">
        <div className="w-full max-w-sm text-center">
          <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-[28px] border border-white/90 bg-white/85 shadow-[0_20px_60px_rgba(21,53,200,0.14)] backdrop-blur">
            <img src="/short_logo2.png" alt="GrowChat" className="splash-logo h-16 w-16 object-contain" />
          </div>
          <img src="/full_logo.png" alt="" aria-hidden="true" className="mx-auto mt-6 h-auto w-44 object-contain" />

          <div className="mx-auto mt-8 h-1.5 w-52 overflow-hidden rounded-full bg-[#dfe5fb]">
            <div className="splash-progress h-full w-2/5 rounded-full bg-gradient-to-r from-[#1535c8] to-[#05bff7]" />
          </div>
          <p className="mt-5 text-sm font-semibold text-[#25315f]">{message}</p>
          {description && <p className="mx-auto mt-2 max-w-xs text-xs leading-5 text-slate-500">{description}</p>}
        </div>
      </div>

      <style>{`
        .splash-orb { position:absolute; border-radius:9999px; filter:blur(10px); opacity:.55; animation:splash-float 7s ease-in-out infinite; }
        .splash-orb-one { width:320px; height:320px; top:-150px; right:-90px; background:radial-gradient(circle,rgba(5,191,247,.28),rgba(5,191,247,0)); }
        .splash-orb-two { width:380px; height:380px; bottom:-210px; left:-120px; background:radial-gradient(circle,rgba(21,53,200,.22),rgba(21,53,200,0)); animation-delay:-3.5s; }
        .splash-logo { animation:splash-breathe 2.4s ease-in-out infinite; }
        .splash-progress { animation:splash-progress 1.35s ease-in-out infinite; }
        @keyframes splash-progress { from { transform:translateX(-110%); } to { transform:translateX(360%); } }
        @keyframes splash-breathe { 0%,100% { transform:scale(1); } 50% { transform:scale(1.045); } }
        @keyframes splash-float { 0%,100% { transform:translate3d(0,0,0); } 50% { transform:translate3d(0,16px,0); } }
        @media (prefers-reduced-motion: reduce) {
          .splash-logo,.splash-progress,.splash-orb { animation:none; }
          .splash-progress { width:100%; opacity:.7; }
        }
      `}</style>
    </div>
  )
}
